/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import BidRequestRepository from 'repositories/loanOfficer/BidRequestRepository';

const initialState = {
  loading: false,
  bidRequests: [],
  meta: {},
};

const BidRequestsSlice = createSlice({
  name: 'BidRequestsSlice',
  initialState,
  reducers: {
    loadBidRequestsStart(state) {
      state.bidRequestsLoading = true;
    },
    loadBidRequestsSuccess(state, { payload }) {
      const { data, meta } = payload;
      const bidRequests = data.map(({ id, attributes }) => ({ id: Number(id), ...attributes }));
      state.bidRequests = bidRequests;
      state.meta = meta;
      state.bidRequestsLoading = false;
    },
    loadBidRequestsFail(state) {
      state.bidRequestsLoading = false;
    },
  },
});

export const { actions } = BidRequestsSlice;

export default BidRequestsSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const loadBidRequests = async () => {
    dispatch(actions.loadBidRequestsStart());
    try {
      const response = await BidRequestRepository.index();
      dispatch(actions.loadBidRequestsSuccess(response));
    } catch (_error) {
      dispatch(actions.loadBidRequestsFail());
    }
  };

  return {
    loadBidRequests,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/bidRequestsSlice.js